const initialState = () => {
  return {
    propertyAddress: {
      streetNameOptions: [],
      propertyId: null,
      isStreetNameValid: null,
      validateAddress: {
        cityPinOptions: []
      }
    },
    estimateDetails: {},
    errors: {
      applicationError: {
        hasError: null,
        error: []
      },
      estimateDetailsError: {
        hasError: null,
        error: []
      },
      maintenanceError: {
        hasError: null,
        error: ""
      }
    }
  };
};

export default initialState;
